import { Component, OnInit, OnChanges, Inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router'

import { PageEvent } from '~Components/pagination/pagination.component';

import { UtilisateurService } from '../../services/utilisateur.service';
import { BaseComponent } from '../../interfaces/basecomponent';

/**
 * Composant pour lister les utilisateurs par fournisseur
 * @extends BaseComponent
 * @implements OnInit, OnChanges
 */
@Component({
  selector: 'app-lister-utilisateur-par-fournisseur',
  templateUrl: './lister-utilisateur-par-fournisseur.component.html',
  styleUrls: ['./lister-utilisateur-par-fournisseur.component.scss']
})
export class ListerUtilisateurParFournisseurComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() codeFournisseur: string = null;

    idUtilisateur: number = null;

    listeUtilisateurs: any[] = [];
    total: number = 0;
    indexPage: number = 0;
    taillePage: number = 10;

    /**
     * Constructeur
     * @param utilisateurService
     * @param route
     */
    constructor(@Inject(UtilisateurService) private utilisateurService: UtilisateurService, private route: ActivatedRoute) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Changements
     */
    ngOnChanges() {
        this.idUtilisateur = null;
        this.indexPage = 0;
        this.lister();
    }

    /**
     * Lister les utilisateurs
     */
    lister() {
        if (this.codeFournisseur) {
            // Liste les utilisateurs
            this.utilisateurService.listerUtilisateursParFournisseur(this.codeFournisseur, this.indexPage, this.taillePage).subscribe((retour: any) => {
                if (retour && retour.Result) {
                    this.listeUtilisateurs = (retour.Result.Liste as any[]);
                    this.total = retour.Result.Total;
                }
            });
        }
    }

    /**
     * Ev�nement lors du changement de page
     * @param e
     */
    public changementPageEvent(e: PageEvent) {
        if (this.indexPage == e.indexPage && this.taillePage == e.taillePage) {
            return;
        }

        this.listeUtilisateurs = [];

        this.indexPage = e.indexPage;
        this.taillePage = e.taillePage;

        this.lister();
    }

    /**
     * S�lectionner l'utilisateur
     * @param idUtilisateur
     */
    public selectionnerUtilisateur(idUtilisateur: number) {
        this.idUtilisateur = idUtilisateur;
    }
}
